<template>
  <div class="c_tooltip tooltip-bottom" :class="{'active': active}" role="tooltip">
    <div class="tooltip-arrow"></div>
    <div class="tooltip-inner">
      <div class="column is-paddingless-bottom">
        <flat-pickr :config="configDate" v-model="range_date"></flat-pickr>
      </div>
      <div class="column">
        <button type="button" class="button is-primary">
        <span class="icon">
            <i class="fa fa-external-link"></i>
        </span>
          <span>Ouvrir en grand</span>
        </button>
        <button type="button" class="button is-primary">
          <span class="icon">
              <i class="fa fa-trash"></i>
          </span>
          <span>Supprimer</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DatePickerTooltip',
    props: {
      active: {
        type: Boolean,
        required: true
      }
    },
    data () {
      return {
        range_date: null,
        configDate: {
          altFormat: 'j/m/Y',
          altInput: true,
          dateFormat: 'd/m/Y',
          mode: 'range',
          inline: true
        }
      }
    },
    computed: {},
    methods: {}
  }
</script>

<style scoped>
  .flatpickr-input {
    opacity: 0;
    width: 0;
    height: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/utils/DatePickerTooltip.vue